<template>
  <form class="user-form" @submit.prevent="onSubmit" style="padding: 0px 10px;">

        <p style="font-size: 20px; margin-left: 9px; margin-bottom: 10px;">{{ user ? user.firstName : 'Create New User' }}</p>

        <b-tabs v-model="activeTab" @change="loadTab" class="has-background-white">

          <b-tab-item label="Details" class="has-background-white">

            <template v-if="isTabLoaded(0)">

              <b-field label="Third Party Code" v-if="user">
                <b-input v-model="user.thirdPartyCode" readonly></b-input>
              </b-field>

              <b-field label="Name">
                <b-input v-model="form.firstName"></b-input>
              </b-field>

              <!-- <b-field label="Last Name">
                <b-input v-model="form.lastName"></b-input>
              </b-field> -->

              <b-field label="Email">
                <b-input v-model="form.email" type="email" key="input-email"></b-input>
              </b-field>
              <b-field label="Mobile">
                <b-input v-model="form.mobile"></b-input>
              </b-field>
              <b-field>
                <b-checkbox
                  v-model="form.emailPasswordLink"
                  :disabled="!validEmail"
                  :true-value="1"
                  :false-value="0"
                >Email Password Link</b-checkbox>
              </b-field>
              <!-- <tags-input label="Tags" allow-new :values.sync="form.tags" /> -->
              <!-- <base-tag-input
                v-if="user"
                :attach-mode="user ? true : false"
                :value.sync="form.tags"
                model-type="person"
                :model-id="user ? user.id : null"
                :fetch-params="{
                  not_types: ['[ORDER][MANDATORY]'],
                }"
                :key="user.id"
              />
              <base-tag-input
                v-else
                :attach-mode="false"
                :value.sync="tagsPermittedOrders"
                :fetch-params="{
                  type: '[ORDER][MANDATORY]',
                  firm_id: undefined
                }"
                :allow-new="false"
              /> -->
              <!-- 2023-03-01 - tags attached to user are only mandatory tags (possible regular tags can be brought back in the future) -->
              <base-tag-input
                :attach-mode="!!user"
                :value.sync="form.tags"
                model-type="person"
                :model-id="user ? user.id : null"
                :fetch-params="{
                  type: '[ORDER][MANDATORY]',
                  firm_id: undefined
                }"
                :allow-new="false"
                @add="onTagsUpdate"
                @remove="onTagsUpdate"
              />

              <b-field label="Spend Limit">
                <b-input v-model="form.spend_limit"></b-input>
              </b-field>

              <b-field label="Start Route">
                <b-select
                  v-model="form.startRoute"
                  expanded
                >
                  <option :value="startRoute.value" v-for="startRoute in startRoutes" :key="startRoute.value">
                    {{ startRoute.label }}
                  </option>
                </b-select>
              </b-field>

              <template v-if="!user">

                <br>

                <div class="columns">
                  <div class="column">
                <div class="field" v-for="(role, key) in filteredRoles">
                    <b-checkbox :native-value="role.id" v-model="defaultRole" :disabled="isTopLevelFirm && isFirst">
                        {{ role.name }}
                    </b-checkbox>
                </div>
                  </div>
                  <div class="column">
                     <div class="field" v-for="contract in contracts" :key="contract.id">
                      <b-checkbox :native-value="contract.id" v-model="form.contracts">
                        {{ contract.contractor ? contract.contractor.name : "" }} - {{ contract.name }}
                      </b-checkbox>
                    </div>
                  </div>
                </div>

                <!-- <div class="field">
                    <b-checkbox v-model="defaultRole.admin">
                        Admin
                    </b-checkbox>
                </div> -->

              </template>

            </template>

          </b-tab-item>

          <b-tab-item label="Roles" class="has-background-white" v-if="user">
            <!--
              REMIDNER: we assign a key to this component so that it re-renders for each user
              and so doesn't treat a change between users with different roles/permissions
              as a user manually making those changes to the roles and/or permissions.
              (since we have cases where removing a role removes child permissions)
            -->
            <rolesAndPermissions
              :checked.sync="form.permissions"
              :checked-roles.sync="form.roles"
              :ishaveValue="form.email ? true : false"
              :organization="organization"
              :defaultRole="defaultRole"
              :key="`roles-and-permissions-${user.id}`"
              ref="rolesAndPermissions"
            />

          </b-tab-item>

          <b-tab-item label="Documents" class="has-background-white"  v-if="user">

              <file-list
                :model="user"
                modelType="person"
                v-if="isTabLoaded(2)"

              />

          </b-tab-item>

          <!-- <b-tab-item label="Scope" v-if="user" class="has-background-white">

            <user-accounts :user="user" v-if="isTabLoaded(3)" />

            <div class="field">
              <label class="label">Permitted Orders</label>
              <div class="control is-clearfix" v-for="(tag, index) in tags" :key="index">
                <b-checkbox :native-value="tag.name" v-model="form.tags">{{ tag.name }}</b-checkbox>
              </div>
            </div>

            <base-tag-input
              attach-mode
              :value.sync="tagsPermittedOrders"
              model-type="person"
              :model-id="user.id"
              :fetch-params="{
                type: '[ORDER][MANDATORY]',
                firm_id: undefined
              }"
              label="Permitted Orders"
              :allow-new="false"
            />

          </b-tab-item> -->
            <b-tab-item label="Notifications" v-if="user">
                <notifications v-if="isTabLoaded(4)" type="Stormport\Persons\Person" :model="user" perPage="1000" />
                <!-- <notifications v-if="isTabLoaded(4)" type="Stormport\Persons\Person" :model="user" perPage="15" /> -->
            </b-tab-item>

          <b-tab-item label="Teleport" v-if="user">

            <div v-if="canViewTeleportations">

              <b-field v-if="canGrantTeleportations">
                <b-select
                  v-model="teleportTargetId"
                  expanded
                >
                  <option :value="null">Select Colleague</option>
                  <option v-for="p in teleport_targets" :value="p.id" :key="p.id">
                    {{ p.firstName }}
                  </option>
                </b-select>
                <b-button type="is-info" @click.prevent.stop="onGrantTeleportIntent">GRANT</b-button>
              </b-field>

              <b-table
                :data="teleportationsInvolvingSelectedUser.length === 0 ? [] : teleportationsInvolvingSelectedUser"
                :bordered="false"
                :striped="false"
                :narrowed="true"
                :hoverable="false"
                :loading="teleport_tab_busy"
                :focusable="false"
                :mobile-cards="false"
                class="mt-1">

                <template slot-scope="props">

                  <b-table-column field="teleport_to_name" label="Account">
                      {{ props.row.teleportTo.fullName }}
                  </b-table-column>

                  <b-table-column field="granted_by_name" label="Access Granted By">
                      {{ props.row.grantedBy.fullName }}
                  </b-table-column>

                  <b-table-column field="" label="">
                      <b-button v-if="canArchiveTeleportationAccess(props.row)" type="is-white" @click="onArchiveTeleportationIntent(props.row.id)">
                        <span class="icon"><i class="fa fa-times-circle fa-lg"></i></span>
                      </b-button>
                  </b-table-column>

                </template>

                <template #empty>
                    <div class="has-text-centered">No access currently granted.</div>
                </template>

              </b-table>
            </div>

            <b-collapse animation="slide" :open.sync="teleportation_logs_primary_open">

              <template #trigger>
                <div class="is-size-5 mt-1" role="button">
                  PRIMARY ACTIVITY
                  <span class="icon">
                    <i class="fa fa-lg" :class="{ 'fa-caret-right': !teleportation_logs_primary_open, 'fa-caret-down': teleportation_logs_primary_open }"></i>
                  </span>
                </div>
              </template>

              <b-table
                :data="teleportActivityLogsPrimary.length === 0 ? [] : teleportActivityLogsPrimary"
                :bordered="false"
                :striped="false"
                :narrowed="true"
                :hoverable="false"
                :loading="teleport_tab_busy"
                :focusable="false"
                :mobile-cards="false"
                class="mt-1">

                <template slot-scope="props">

                  <b-table-column field="created_at" label="Date">
                      {{ props.row.createdAt | toLocalDateAndTime }}
                  </b-table-column>

                  <b-table-column field="content" label="Activity">
                      {{ props.row.content }}
                  </b-table-column>

                </template>

                <template #empty>
                    <div class="has-text-centered">No activity found.</div>
                </template>

              </b-table>

            </b-collapse>

            <b-collapse animation="slide" :open.sync="teleportation_logs_secondary_open">

              <template #trigger>
                <div class="is-size-5 mt-1" role="button">
                  SECONDARY ACTIVITY
                  <span class="icon">
                    <i class="fa fa-lg" :class="{ 'fa-caret-right': !teleportation_logs_secondary_open, 'fa-caret-down': teleportation_logs_secondary_open }"></i>
                  </span>
                </div>
              </template>

              <b-table
                :data="teleportActivityLogsSecondary.length === 0 ? [] : teleportActivityLogsSecondary"
                :bordered="false"
                :striped="false"
                :narrowed="true"
                :hoverable="false"
                :loading="teleport_tab_busy"
                :focusable="false"
                :mobile-cards="false"
                class="mt-1">

                <template slot-scope="props">

                  <b-table-column field="created_at" label="Date">
                      {{ props.row.createdAt | toLocalDateAndTime }}
                  </b-table-column>

                  <b-table-column field="content" label="Activity">
                      {{ props.row.content }}
                  </b-table-column>

                </template>

                <template #empty>
                    <div class="has-text-centered">No secondary activity found.</div>
                </template>

              </b-table>

            </b-collapse>

          </b-tab-item>

          <b-tab-item label="Contracts" class="has-background-white" v-if="user">
            <user-contracts
              :user="user"
              v-if="isTabLoaded(5)"
            />
          </b-tab-item>
        </b-tabs>

        <footer class="card-footer" v-if="activeTab != 2 && activeTab != 4 && activeTab != 5">

            <div class="columns">

                <div class="column">

                    <button class="button is-info user-buttons" style="margin-left:5px;" :disabled="!user ? !canManageUsers : false">{{ user ? 'UPDATE' : 'CREATE' }}</button>

                    <template v-if="user">

                        <template v-if="user.id != $store.state.Auth.user.id">

                          <b-button class="user-buttons" type="is-danger" :loading="deleting" @click="onRemove" v-if="canManageUsers && isSuperAdmin">DELETE</b-button>

                          <b-button class="user-buttons" type="is-dark" :disabled="!canManageUsers" @click="restore" :loading="restoring" v-if="canArchive && user.archivedAt">RESTORE</b-button>

                          <b-button class="user-buttons" type="is-warning" :disabled="!canManageUsers" :loading="archiving" @click="archive" v-if="canArchive && !user.archivedAt">ARCHIVE</b-button>

                        </template>

                        <b-button
                            :loading="teleporting == user.id"
                            :disabled="user.id == $store.state.Auth.user.id || user.archivedAt"
                            @click="teleport(user.id)"
                            class="teleport user-buttons is-danger"
                            v-if="canTeleportAs(user)"
                        >
                            TELEPORT
                        </b-button>

                    </template>


                    <button type="button" class="button user-buttons">CANCEL</button>
<!--
                    <button type="button" class="button is-danger" style="float:right;" v-if="user">DELETE</button>

                    <button type="button" class="button is-warning" style="float:right; margin-right:5px;" v-if="user">ARCHIVE</button>

                    <button type="button" class="button" style="float:right; margin-right:5px;" v-if="user">TELEPORT</button> -->

<!--                     <b-button
                        native-type="submit"
                        type="is-link"
                        :loading="loading"
                        :disabled="!user ? !canManageUsers : false"
                    >
                        <span v-if="user">UPDATE</span>
                        <span v-else>CREATE</span>
                    </b-button>
 -->


                </div>
            </div>
        </footer>

  </form>
</template>

<script>
import PermissionCheckboxes from "@/components/Permission/PermissionCheckboxes";
import rolesAndPermissions from "./rolesAndPermissions";
import Roles from "@/helpers/roles";
import { AuthService } from "@/services/auth.service";
import { ContractService } from "@/services/contract.service";
import { UserService } from "@/services/user.service";
import { TeleportationService } from "@/services/teleportation.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { startRoutes } from "@/helpers/start-routes";
import { TagService } from "@/services/tag.service";
import ListDocuments from "@/components/Documents/ListDocuments";
import FileList from "@/components/File/FileList";
import TagsInput from "@/components/partials/TagsInput";
import { startRouteMixin } from "@/mixins/startRouteMixin";
import { RoleService } from "@/services/role.service";
import Permissions from "@/helpers/permissions";
import UserAccounts from "./userAccounts";
import Notifications from "./notification";
import { tabsMixin } from "@/mixins/tabsMixin";
import BaseTagInput from "@/components/partials/BaseTagInput";
import UserContracts from "./userContracts";

export default {
  props: {
    organization: {
      type: Object,
      required: true
    },
    user: {
      type: Object
    },
    height: {
      type: Number,
      default: 0
    },
    keyword: {
      type: String
    },
    // Is the first user
    isFirst: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PermissionCheckboxes,
    rolesAndPermissions,
    ListDocuments,
    FileList,
    TagsInput,
    UserAccounts,
    Notifications,
    BaseTagInput,
    UserContracts,
  },

  mixins: [startRouteMixin, tabsMixin],

  data: () => ({
    activeTab: 0,
    contracts: [],
    allRoles: [],
    authService: AuthService,
    userService: UserService,
    tagService: TagService,
    form: {
      firstName: "",
      // lastName: "",
      email: "",
      mobile: "",
      hasMobileApplication: 0,
      hasEmailNotification: 0,
      hasSmsNotification: 0,
      isActive: 1,
      permissions: [],
      contracts: [],
      roles: [],
      tags: [],
      emailPasswordLink: null,
      spend_limit: null,
      startRoute: "profile",
    },
    validEmail: false,
    loading: false,
    archiving: false,
    restoring: false,
    deleting: false,
    forgetting: false,
    containerHeight: 0,
    tags: [],
    // tagsPermittedOrders: [],
    teleporting: null,
    teleport_activity: [],
    teleportation_logs_primary_open: false,
    teleportation_logs_secondary_open: false,
    teleportations_from_auth_user: [],
    teleportations_involving_selected_user: [],
    teleportTargetId: null,
    teleport_targets: [],
    teleport_tab_busy: null,
    defaultRole: [],
    startRoutes: [],
  }),
  computed: {
    filteredRoles() {

      // if (this.isSuperAdmin) {
          // return this.allRoles.filter(element => {
          //     if (element.type) {
          //         return element.type.toUpperCase().includes('[SYSTEM][ROLE]');
          //     }
          //     return false;
          // });
      // } else {
          let roles = this.allRoles.filter(element => {
              if (element.name.toUpperCase() == 'SUPERADMIN' && !this.isSuperAdmin) {
                  return false;
              }
              if (true) {}
                let managed = false;
                if (this.organization.managed_by) {
                   managed = element.managed_by_firm_id == this.organization.managed_by;
                } else {
                   managed = element.managed_by_firm_id == this.organization.id;
                }

              let tag = false;
              if (element.tags.length) {
                  tag = element.tags.find(tag => tag.type.toUpperCase() == '[SYSTEM]');
              }
              return managed || tag;
          });
          // return roles;
          roles = roles.filter(element => {
            return element.type && element.type.toUpperCase().includes('[SYSTEM][ROLE]')
          });

          roles = roles.filter(r => {
            return ( ! r.archived_at);
          });

          return _.sortBy(roles, r => {
            return r.name.toLowerCase();
          });
      // }

  },
    scrollableHeight() {
      return this.height - 86 - 76; // header height, footer height
    },
    isTopLevelFirm() {
      return !this.organization.managed_by;
    },
    isSuperAdmin() {
      return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
    },
    isAdmin() {
      return this.$store.getters["Auth/hasRole"](Roles.ADMIN);
    },
    isUserSuperadmin() {
      return !!(this.user.roles || []).find(p => p.name === "superadmin");
    },
    canViewTeleportations() {
      // Teleportations are only granted by firms that aren't managed by the auth user's firm.
      let can = false;
      let authUser = this.$store.state.Auth.user;
      if (
        this.organization.id != authUser.firmId &&
        this.organization.managed_by != authUser.firmId &&
        this.organization.id != authUser.firm.managed_by
      ) {
        can = true;
      }
      return can;
    },
    canGrantTeleportations() {
      return (this.canViewTeleportations && this.$store.getters["Auth/hasRole"](Roles.ADMIN));
    },
    canManageUsers() {
      return this.$store.getters["Auth/hasPermission"]("can manage users");
    },

    canViewDocuments() {

      return this.$store.getters["Auth/hasPermission"]("can view documents");

    },

    canArchive() {
      // Admin can't archive superadmin accounts
      return (this.isSuperAdmin || (this.isAdmin && !this.isUserSuperadmin));
    },

    startRoute() {
      const attributes = this.user.attributes || [];

      const attribute = attributes.find(
        attribute => attribute.code === "start_route"
      );

      return attribute ? attribute.value : "profile";
    },

    teleportActivityLogsPrimary() {
      let items = [];
      const selected_user_id = (this.user && this.user.id)
        ? this.user.id
        : null;
      if (selected_user_id) {
        this.teleportations_involving_selected_user.forEach(t => {
          let logs = t.logs || [];
          logs.forEach(log => {
            if (t.teleport_to_id == selected_user_id) items.push(log);
          });
        });
        this.teleport_activity.forEach(log => {
          if (log.loggable_id == selected_user_id) {
            items.push(log);
          }
        });
      }
      items = _.sortBy(items, 'createdAt').reverse().slice(0, 100);
      return items;
    },

    teleportActivityLogsSecondary() {
      let items = [];
      // const auth_user_id = this.$store.state.Auth.user.id;
      const selected_user_id = (this.user && this.user.id)
        ? this.user.id
        : null;
      if (selected_user_id) {
        this.teleportations_involving_selected_user.forEach(t => {
          let logs = t.logs || [];
          logs.forEach(log => {
            if (t.teleport_from_id == selected_user_id) {
              if (_.startsWith(log.subtype, 'TELEPORT_ACCESS_GRANTED')) items.push(log);
              if (_.startsWith(log.subtype, 'TELEPORT_ACCESS_ARCHIVED')) items.push(log);
            }
            if (log.created_by == selected_user_id) {
              items.push(log);
            }
          });
        });
        this.teleport_activity.forEach(log => {
          if (log.created_by == selected_user_id && log.loggable_id != selected_user_id) {
            items.push(log);
          }
        });
      }
      items = _.sortBy(items, 'createdAt').reverse().slice(0, 100);
      return items;
    },

    teleportationsInvolvingSelectedUser() {
      let items = [];
      this.teleportations_involving_selected_user.forEach(t => {
        // Hide archived items. They are available client side
        // because we needed access to their included logs.
        if ( ! t.archived_at) items.push(t);
      });
      return items;
    },
  },
  watch: {
      defaultRole(value) {
            let checkedRoles = [];
            let checkedPermissions = [];
            value.forEach((v, k) => {
              checkedRoles.push(v);
              let role = this.filteredRoles.find(element => element.id == v);
              if (role.permissions.length) {
                checkedPermissions.push(role.permissions.map(element => element.id));
              }
            });
            let x = checkedPermissions.flat();
            let y = Array.from(new Set(x));
            this.form.roles = checkedRoles;
            this.form.permissions = y;
        },
    "form.email"(value) {
      var re = /\S+@\S+\.\S+/;
      this.validEmail = re.test(value);
    },
    user: {
      handler(user) {
        // this.defaultRole = [];
        // alert();
        if (user) {
          this.fillData(user);
          // this.form.roles = this.user.roles.map(element => element.id);
          this.loadTeleportActivity();
          this.getTeleportationsInvolvingSelectedUser();

        } else {
          this.activeTab = 0;
          this.resetForm();
        }
      },
      deep: true
    },

    keyword(value) {

      this.form.firstName = value;

    },

    isFirst() {
      this.setDefaultRoles();
    },

  },
  mounted() {
    this.startRoutes = startRoutes;

    this.getContracts();
    this.getRoles();
    // this.getTags();
    this.getTeleportTargets(this.$store.state.Auth.user.firmId);
    // Note which users the authenticated user has been explicitly been given teleport access for.
    this.getTeleportations({ teleport_from_id: this.$store.state.Auth.user.id })
      .then(teleportations => {
        this.teleportations_from_auth_user = teleportations;
      })
      .catch(err => {
        this.$buefy.toast.open({
          message: "Error retrieving teleportations access data.",
          type: "is-danger",
          position: "is-top-right"
        });
      });
    if (this.user) {
      this.$nextTick(() => {
        this.fillData(this.user);
      });
    }else{

      // 2022-09-15 - setDefaultRoles()

      // if (!this.isSuperAdmin) { return false; }

      // RoleService.all({includes: 'permissions'}).then(response => {

      //   let data = JsonDenormalizer.denormalize(response);

      //   data = data.filter(role => {

      //     return role.name.toLowerCase() == 'administrator';
      //     // return role.name.toLowerCase() == 'admin';

      //   });

      //   this.form.roles = data.map(a => a.id);


      //   if (data.length) {

      //     let permissionIds = [];

      //     data[0].permissions.forEach(permission => {

      //       permissionIds.push(permission.id);

      //     });

      //     this.form.permissions = permissionIds;

      //   }

      // });


    }
  },
  methods: {
    async getContracts() {
      this.contracts = await ContractService.all({
        exclude_archived: 1,
        includes: 'contractor',
      }).then(response => JsonDenormalizer.denormalize(response));
    },
    setDefaultRoles() {
      if (this.isTopLevelFirm && this.isFirst) {
          this.defaultRole = this.allRoles.filter(v => v.name == "superadmin").map(v => v.id);
      } else {
        this.defaultRole = [];
      }
    },
    async getRoles(autoSelect = false) {
      // await RoleService.getTags({ permissions: true }).then(response => {
      //   this.allRoles = response;
      // });
      // TODO - single source for roles in form and roles tab
      this.allRoles = await RoleService.all({
        type: "person",
        includes: "permissions,tags,tags"
      }).then(response => JsonDenormalizer.denormalize(response));

      if (this.$refs.rolesAndPermissions) {
        this.$refs.rolesAndPermissions.fetchRoles()
        this.$refs.rolesAndPermissions.getAllPermissions()
      }

      this.setDefaultRoles();

    },
    fillData(user) {
      // console.log(user);
      this.form = {
        firstName: user.firstName,
        // lastName: user.lastName,
        email: user.email || "",
        mobile: user.mobile || "",
        hasMobileApplication: user.groupIdApp,
        hasEmailNotification: user.orderRecipient,
        hasSmsNotification: user.orderRecipientSms,
        isActive: user.active ? 1 : 0,
        spend_limit: user.spend_limit || "",
        startRoute: this.startRoute,
        // permissions:
        //   this.canManageUsers && user.permissions
        //     ? user.permissions.map(permission => permission.id)
        //     : [],

        permissions: user.permissions ? user.permissions.map(permission => permission.id) : [],

        roles:
          user.roles
            ? user.roles.map(role => role.id)
            : [],
        // tags: user.tags ? user.tags.map(tag => tag.name) : []
      };
      this.form.tags = user.tags ? user.tags.filter(tag => tag.type == "[ORDER][MANDATORY]").map(tag => tag.name) : [];
      // this.tagsPermittedOrders = user.tags ? user.tags.filter(tag => tag.type === "[ORDER][MANDATORY]").map(tag => tag.name) : [];
    },
    async getTags() {
      const tags = await this.tagService
        .all({ type: "[SYSTEM][ACCESS][ORDERS]", includes: "tags" })
        .then(response => JsonDenormalizer.denormalize(response));

      if (tags.length) {
        this.tags = tags[0].tags || [];
      }
    },
    getTeleportTargets(firm_id) {
      return this.userService.all({ firmId: firm_id })
        .then(res => {
          let teleport_targets = JsonDenormalizer.denormalize(res);
          teleport_targets = _.filter(teleport_targets, person => {
            return ! person.archivedAt;
          })
          this.teleport_targets = teleport_targets;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTeleportations(params) {
      return TeleportationService.all(params)
        .then(res => {
          let teleportations = JsonDenormalizer.denormalize(res);
          return teleportations;
        })
        .catch(err => {
          throw err;
        });
    },
    getTeleportationsInvolvingSelectedUser() {
      const teleport_involving_id = (this.user && this.user.id) ? this.user.id : null;
      if ( ! teleport_involving_id) {
        this.teleportations_involving_selected_user = [];
        return Promise.resolve([]);
      }
      this.teleport_tab_busy = true;
      return this.getTeleportations({
        include_archived : 1,
        teleport_involving_id : teleport_involving_id,
        includes: 'teleportTo,teleportFrom,grantedBy,logs'
      })
        .then(teleportations => {
          this.teleportations_involving_selected_user = teleportations;
          return teleportations;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.teleport_tab_busy = false;
        });
    },
    transformedData() {
      return {
        admin: false,
        first_name: this.form.firstName,
        // last_name: this.form.lastName,
        email_address: this.form.email,
        mobile_number: this.form.mobile,
        group_id_app: this.form.hasMobileApplication,
        order_recipient: this.form.hasEmailNotification,
        order_recipient_sms: this.form.hasSmsNotification,
        active: this.form.isActive,
        firm_id: this.organization.id,
        contract_ids: this.form.contracts,
        permission_ids: this.form.permissions,
        role_ids: this.form.roles,
        // tags: this.form.tags,
        // tags: [
        //   ...(this.form.tags || []),
        //   ...(this.tagsPermittedOrders || []),
        // ],
        // Tags are attached immediately on select in update form
        tags_mandatory: this.user ? undefined : (this.form.tags || []),
        // tags_mandatory: this.tagsPermittedOrders || [],
        emailPasswordLink: this.form.emailPasswordLink,
        spend_limit: this.form.spend_limit,
        start_route: this.form.startRoute,
      };
    },
    resetForm() {
      this.form = {
        firstName: "",
        // lastName: "",
        email: "",
        mobile: "",
        hasMobileApplication: 0,
        hasEmailNotification: 0,
        hasSmsNotification: 0,
        isActive: 1,
        contracts: [],
        permissions: [],
        roles: [],
        tags: []
      };
      this.setDefaultRoles();
      // // Clear out mandatory tags
      // this.tagsPermittedOrders = [];
    },
    onSubmit() {
      if (this.user) {
        this.update();
      } else {
        this.create();
      }
    },
    async create() {
      this.loading = true;

      try {
        await this.userService.store(this.transformedData()).then(response => {
          this.$buefy.toast.open({
            message: "User has been created.",
            type: "is-info",
            position: "is-top-right"
          });
          this.resetForm();

          // this.$emit("create-success");
          const user = JsonDenormalizer.denormalize(response);
          this.$emit("callback", user);

          // this.$emit('updateSelectedUser', response)
          // this.defaultRole.admin   = false;
          // this.defaultRole.general = false;

        });


      } catch (err) {}

      this.loading = false;
    },
    async update() {
      this.loading = true;
      try {
        const response = await this.userService.update(this.user.id, {
          ...this.transformedData(),
          includes: "permissions,roles,tags"
        });
        const user = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "User has been updated.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("callback", user);

        // this.$emit("person", user);
        // this.$emit("user", user);

      } catch (err) {}

      this.loading = false;



    },
    async archive() {
      this.archiving = true;

      try {
        const response = await this.userService.archive(this.user.id, {
          includes: "permissions,roles"
        });
        const user = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "User has been archived.",
          type: "is-info",
          position: "is-top-right"
        });
        // this.$emit("archive-success", user);
        this.$emit("callback", user);
        // this.$parent.userFormCallback(user);

      } catch (err) {}

      this.archiving = false;
    },
    async restore() {
      this.restoring = true;

      try {
        const response = await this.userService.restore(this.user.id, {
          includes: "permissions,roles"
        });
        const user = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "User has been restored.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("callback", user);
        // this.$parent.userFormCallback(user);

        // this.$emit("restore-success", user);

      } catch (err) {}

      this.restoring = false;
    },
    onRemove() {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this user?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove();
        }
      });
    },
    async remove() {
      this.deleting = true;

      try {
        await this.userService.delete(this.user.id);

        this.$buefy.toast.open({
          message: "User has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });

        // this.$parent.userFormCallback(null);
        this.$emit("callback", null);
        this.deleting = false;
        // this.$emit("remove-success", this.user.id);

      } catch (err) {}

      this.deleting = false;
    },
    async forgotPassword() {
      this.forgetting = true;

      try {
        await this.authService.forgotPassword({
          email_address: this.user.email
        });

        this.$buefy.toast.open({
          message: "Credentials has been sent.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.forgetting = false;
    },

    async teleport(id) {
      this.teleporting = id;

      try {
        const token = await this.authService.teleport({id}).then(response => response.data.token);

        this.$store.dispatch("Auth/setToken", token);
        this.navigateToStartRoute();

      } catch (err) {}

      // this.teleporting = null;
    },

    canTeleportAs(user) {

      // Admin can't teleport to superadmin accounts
      if (this.isAdmin && this.isUserSuperadmin) return false;

        const unteleportable_account_permission = user.permissions.find(p => p.name.toLowerCase() == 'unteleportable account');
        const unteleportable_account = unteleportable_account_permission ? true : false;

        return this.isSuperAdmin ||

          (this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE) &&

          this.$store.state.Auth.user.firmId == user.firmId &&

          ( ! unteleportable_account)) ||

          (this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_MANAGED_USER) &&

          this.$store.state.Auth.user.firmId == this.organization.managed_by) ||

          (this.hasTeleportAccessManuallyGranted(user.id, this.$store.state.Auth.user.id));

    },

    hasTeleportAccessManuallyGranted(to_id, from_id) {
      let can = false;
      if (to_id && from_id) {
        to_id = parseInt(to_id, 10);
        from_id = parseInt(from_id, 10);
        const accessRecord = _.find(this.teleportations_from_auth_user, { teleport_to_id: to_id, teleport_from_id: from_id });
        if (accessRecord) can = true;
      }
      return can;
    },

    onGrantTeleportIntent() {
      let teleportationRecord;
      const target_id = this.teleportTargetId;
      this.teleport_tab_busy = true;
      TeleportationService.create({
        teleport_to_id: target_id,
        teleport_from_id: this.user.id
      })
      .then(res => {
        // teleportationRecord = JsonDenormalizer.denormalize(res);
        this.$buefy.toast.open({
          message: "Teleportation access details saved.",
          type: "is-success",
          position: "is-top-right"
        });
        return Promise.all([
          this.loadTeleportActivity(),
          this.getTeleportationsInvolvingSelectedUser()
        ]);
      })
      .then(res => {
        return teleportationRecord;
      })
      .catch(err => {
        this.$buefy.toast.open({
          message: "Failed while saving/retrieving teleportation data.",
          type: "is-danger",
          position: "is-top-right"
        });
      })
      .finally(() => {
        this.teleport_tab_busy = false;
      });
    },

    onArchiveTeleportationIntent(teleportation_id) {
      this.teleport_tab_busy = true;
      TeleportationService.archive(teleportation_id)
        .then(res => {
          this.$buefy.toast.open({
            message: "Teleportation access details saved.",
            type: "is-success",
            position: "is-top-right"
          });
          return Promise.all([
            this.loadTeleportActivity(),
            this.getTeleportationsInvolvingSelectedUser()
          ]);
        })
        .catch(err => {
          this.$buefy.toast.open({
            message: "Failed while saving/retrieving teleportation data.",
            type: "is-danger",
            position: "is-top-right"
          });
        })
        .finally(() => {
          this.teleport_tab_busy = false;
        });
    },

    loadTeleportActivity() {
      this.teleport_activity = [];
      const for_firm_id = this.$store.state.Auth.user.firmId;
      const for_user_id = this.user && this.user.id ? this.user.id : null;
      if (for_user_id && for_firm_id) {
        UserService.getTeleportActivity(for_user_id, { firm_id: for_firm_id })
          .then(res => {
            const logs = JsonDenormalizer.denormalize(res);
            this.teleport_activity = logs;
          })
          .catch(err => {
            console.log(err);
          });
      }
      else {
        this.teleport_activity = [];
      }
    },

    canArchiveTeleportationAccess(teleportation)
    {
      // This check is basic and only works within the context of viewing an eligible firm.
      // It does not cover all of the logic necessary to do a complete check from scratch
      const authUser = this.$store.state.Auth.user;
      const is_admin = this.$store.getters["Auth/hasRole"](Roles.ADMIN);
      return is_admin ||
        teleportation.teleport_to_id == authUser.id ||
        teleportation.teleport_from_id == authUser.id;
    },

    onTagsUpdate() {
      // If attached mode
      if (!!this.user) {
        this.$emit("update-tags");
      }
    }

  }
};
</script>

<style scoped>

    .user-buttons{
        float: right;
        margin-right: 5px;
    }

</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/persons/userForm.vue